<template lang="html">
    <transition name="dropdownx">
        <div
            v-show="visible"
            ref="options"
            :style="{
                left: `${left}px`,
                top: `${top}px`
            }"
            class="con-vs-dropdown--menu vs-dropdown-menu"
        >
            <div v-if="align_x == 'bottom'" class="gutter top">
                <div
                    v-if="!hidePointer"
                    class="pointer"
                    :style="{ 'left': `${pointerLeft}px`, 'background-color': color_x }"
                />
            </div>
            <div class="flex" :style="tooltipStyle">
                <div
                    v-if="align_x == 'right'"
                    class="gutter left"
                    :style="{ height: `${menuHeight}px` }"
                >
                    <div
                        v-if="!hidePointer"
                        class="pointer"
                        :style="{ 'top': `${pointerTop_x}px`, 'background-color': color_x }"
                    />
                </div>
                <div
                    class="vs-dropdown--custom vs-dropdown--menu flex-shrink"
                    :style="{ 'background-color': color_x }"
                >
                    <div class="menu-content">
                        <slot />
                    </div>
                </div>
                <div
                    v-if="align_x == 'left'"
                    class="gutter right"
                    :style="{ height: `${menuHeight}px` }"
                >
                    <div
                        v-if="!hidePointer"
                        class="pointer"
                        :style="{ 'top': `${pointerTop_x}px`, 'background-color': color_x }"
                    />
                </div>
            </div>
            <div v-if="align_x == 'top'" class="gutter bottom">
                <div
                    v-if="!hidePointer"
                    class="pointer"
                    :style="{ 'left': `${pointerLeft}px`, 'background-color': color_x }"
                />
            </div>
        </div>
    </transition>
</template>

<script>
import { mapState } from 'vuex'
import _color from '@/assets/utils/color.js'

export default {
    name: 'vx-dropdown-menu',
    props: {
        color: {
            type: String,
            default: ''
        },
        openOnClick: {
            type: Boolean
        },
        visible: {
            type: Boolean
        },
        justify: {
            type: String,
            validate: (v) => ['start', 'middle', 'end'].contains(v),
            default: 'center'
        },
        align: {
            type: String,
            validate: (v) => ['top', 'bottom', 'left', 'right'].contains(v),
            default: 'bottom'
        },
        hidePointer: {
            type: Boolean
        },
        tooltipStyle: {
            type: Object
        }
    },
    watch: {
        visible: {
            handler(val) {
                if (!val) {
                    return
                }
                this.changePositionMenu()
            },
            immediate: true
        },
        windowWidth() {
            this.changePositionMenu()
        }
    },
    data: () => ({
        left: 0,
        top: 0,
        right: true,
        parentNode: null,
        minWindowMargin: 25,
        pointerLeft: 0,
        pointerTop: 0,
        alignOverride: null,
        justifyOverride: null,
        menuHeight: 0
    }),
    computed: {
        ...mapState({ windowWidth: 'windowWidth' }),
        color_x() {
            var color = _color.getColorString(this.color)
            if (color) {
                return `${color} !important`
            }
            return ''
        },
        pointerTop_x() {
            if (this.align_x == 'left') {
                // adjustment value to fixed transform
                return this.pointerTop - 4
            }
            return this.pointerTop
        },
        align_x() {
            return this.alignOverride || this.align
        },
        justify_x() {
            return this.justifyOverride || this.justify
        },
        isVerticallyAligned() {
            // in a vertical alignment, x is determined by the justification
            // and y by the alignment.
            // in a horizontal alignment, x is determined by the alignment
            // and y by the justification.
            return this.align == 'top' || this.align == 'bottom'
        },
        isVerticallyAlignedAfterOverrides() {
            // in a vertical alignment, x is determined by the justification
            // and y by the alignment.
            // in a horizontal alignment, x is determined by the alignment
            // and y by the justification.
            return this.align_x == 'top' || this.align_x == 'bottom'
        }
    },
    methods: {
        insertBody() {
            let elp = this.$el
            this.parentNode = this.$el.parentNode
            document.body.insertBefore(elp, document.body.firstChild)
        },
        setXCoordinates() {
            var menu = this.$el
            var parentRect = this.$parent.$el.getBoundingClientRect()
            var left = parentRect.left + menu.clientWidth
            var offset = menu.clientWidth - parentRect.width

            if (this.isVerticallyAligned) {
                switch (this.justify) {
                    case 'center':
                        left -= offset / 2
                        break
                    case 'end':
                        left -= offset
                        break
                }
            } else {
                switch (this.align) {
                    case 'left':
                        left -= menu.clientWidth
                        break
                    case 'right':
                        left += parentRect.width
                        break
                }
            }

            var overflowingRight = left > window.innerWidth
            var overflowingLeft = left - menu.clientWidth - this.minWindowMargin < 0
            if (this.isVerticallyAligned) {
                if (overflowingLeft && !overflowingRight) {
                    left = this.minWindowMargin + menu.clientWidth
                }
                if (overflowingRight && !overflowingLeft) {
                    left -= left - window.innerWidth + this.minWindowMargin
                }
            } else {
                this.alignOverride = null
                if (overflowingLeft) {
                    this.alignOverride = 'right'
                    left = parentRect.left + menu.clientWidth + parentRect.width
                }
                if (overflowingRight) {
                    this.alignOverride = 'left'
                    left = parentRect.left
                }
            }

            if (this.isVerticallyAligned) {
                var dropPos = {
                    left: parentRect.left,
                    right: parentRect.left + parentRect.width
                }
                var menuPos = {
                    left: left - menu.clientWidth,
                    right: left
                }
                var overlap = {
                    l: Math.max(menuPos.left, dropPos.left),
                    r: Math.min(menuPos.right, dropPos.right)
                }

                var pointerL = dropPos.left - menuPos.left - 14.5 + (overlap.r - overlap.l) / 2
                this.pointerLeft = pointerL
            } else {
                this.pointerLeft = 0
            }
            this.left = left
        },
        setYCoordinates() {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop
            var parentRect = this.$parent.$el.getBoundingClientRect()
            var menu = this.$el
            var top = parentRect.top + scrollTop
            this.menuHeight = menu.clientHeight

            if (this.isVerticallyAligned) {
                switch (this.align) {
                    case 'top':
                        top -= menu.clientHeight
                        break
                    case 'bottom':
                        top += parentRect.height
                        break
                }
            } else {
                var offset = menu.clientHeight - parentRect.height
                switch (this.justify) {
                    case 'center':
                        top -= offset / 2
                        break
                    case 'end':
                        top -= offset
                        break
                }
            }

            var bottomOfMenu = top + menu.clientHeight + this.minWindowMargin
            var topOfMenu = top - this.minWindowMargin
            var overflowingAbove = topOfMenu < 0
            var overflowingBelow = bottomOfMenu > window.innerHeight

            if (this.isVerticallyAligned) {
                this.alignOverride = null
                if (overflowingAbove) {
                    this.alignOverride = 'bottom'
                    top = parentRect.bottom
                }
                if (overflowingBelow) {
                    this.alignOverride = 'top'
                    top = parentRect.top - menu.clientHeight
                }
            } else {
                if (overflowingAbove) {
                    top -= topOfMenu
                }
                if (overflowingBelow) {
                    top -= bottomOfMenu - window.innerHeight
                }
            }

            if (!this.isVerticallyAligned) {
                var dropPos = {
                    top: parentRect.top,
                    bottom: parentRect.top + parentRect.height
                }
                var menuPos = {
                    top: top,
                    bottom: top + menu.clientHeight
                }
                var overlap = {
                    t: Math.max(menuPos.top, dropPos.top),
                    b: Math.min(menuPos.bottom, dropPos.bottom)
                }
                // left needs 14.5 to align to center, right needs 10.5
                var pointerT = dropPos.top - menuPos.top - 10.5 + (overlap.b - overlap.t) / 2
                this.pointerTop = pointerT
            } else {
                this.pointerTop = 0
            }

            this.top = top
        },
        changePositionMenu() {
            this.$nextTick(() => {
                this.setYCoordinates()
                this.setXCoordinates()
            })
        }
    },
    mounted() {
        this.insertBody()
    },
    beforeDestroy() {
        if (this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_variables.scss';

.theme-dark {
    .pointer {
        background-color: $content-dark-bg !important;
        border-color: $theme-dark-border-color !important;
    }
    .con-vs-dropdown--menu {
        .vs-dropdown--menu {
            background-color: $content-dark-bg !important;
        }
    }
}
.con-vs-dropdown--menu {
    padding: 0 !important;
    .vs-dropdown--menu {
        z-index: 4;
        padding: 0 !important;
    }
    .menu-content {
        z-index: 4;
    }

    .gutter {
        position: relative;
        z-index: 3;
        overflow: hidden;

        .pointer {
            position: absolute;
            width: 15px;
            height: 15px;
            display: block;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            border-top: 1px solid rgba(0, 0, 0, 0.1);
            border-left: 1px solid rgba(0, 0, 0, 0.1);
            background: #fff;
        }

        &.left,
        &.right {
            width: 12px;
        }
        &.top,
        &.bottom {
            height: 12px;
            width: 100%;
        }
        &.top {
            transform: translateY(1px);
            .pointer {
                -webkit-transform: rotate(45deg) translateX(10px);
                transform: rotate(45deg) translateX(10px);
            }
        }
        &.bottom {
            transform: translateY(-1px);
            .pointer {
                -webkit-transform: rotate(225deg) translateY(10px);
                transform: rotate(225deg) translateY(10px);
            }
        }
        &.left {
            transform: translateX(1px);
            .pointer {
                -webkit-transform: rotate(315deg) translateY(6px);
                transform: rotate(315deg) translateY(6px);
            }
        }
        &.right {
            transform: translateX(-1px);
            .pointer {
                -webkit-transform: rotate(135deg) translateX(10px);
                transform: rotate(135deg) translateX(10px);
            }
        }
    }
}
</style>
